import { isNil } from "lodash";
import { HintRandomizerDto } from "./HintsAutocomplete";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";



export const useGetHintDead = (hint: HintRandomizerDto | null | undefined)  => {

    let barrens = useSelector((state: AppState) => state.ui.ootr.main.barren);


    if(isNil(hint))
        return false;

    return (hint?.name.startsWith("LW") && barrens.some(x => x.name === "Lost Wood")) ||
            (hint?.name.startsWith("HF") && barrens.some(x => x.name === "Hyrule Field")) ||
            (hint?.name.startsWith("Kak") && barrens.some(x => x.name === "Kakarico Village")) ||
            (hint?.name.startsWith("ZR") && barrens.some(x => x.name === "Zora River")) ||
            (hint?.name.startsWith("ZD") && barrens.some(x => x.name === "Zora's Domain")) ||
            (hint?.name.startsWith("ZF") && barrens.some(x => x.name === "Zora's Fountain")) ||
            (hint?.name.startsWith("DMT") && barrens.some(x => x.name === "Death Mountain Trail")) ||
            (hint?.name.startsWith("DMC") && barrens.some(x => x.name === "Death Mountain Crater")) ||
            (hint?.name.startsWith("Market") && barrens.some(x => x.name === "Market")) ||
            (hint?.name.startsWith("KF") && barrens.some(x => x.name === "Kokiri Forest")) ||
            (hint?.name.startsWith("SFM") && barrens.some(x => x.name === "Sacred Forest Meadow")) ||
            (hint?.name.startsWith("LH") && barrens.some(x => x.name === "Lake Hylia")) ||
            (hint?.name.startsWith("GV") && barrens.some(x => x.name === "Gerudo Valley")) ||
            (hint?.name.startsWith("GF") && barrens.some(x => x.name === "Gerudo Fortress")) ||
            (hint?.name.startsWith("GC") && barrens.some(x => x.name === "Goron City")) ||
            (hint?.name.startsWith("Bottom of the Well") && barrens.some(x => x.name === "Bottom of the Well")) ||
            (hint?.name.startsWith("Gerudo Training Ground") && barrens.some(x => x.name === "Gerudo Training Ground")) ||
            (hint?.name.startsWith("Ice Cavern") && barrens.some(x => x.name === "Ice Cavern")) ||
            (hint?.name.startsWith("Deku Tree") && barrens.some(x => x.name === "Deku Tree")) ||
            (hint?.name.startsWith("Dodongos Cavern") && barrens.some(x => x.name === "Dodongo's Cavern")) ||
            (hint?.name.startsWith("Jabu Jabus Belly") && barrens.some(x => x.name === "Jabu Jabu's Belly")) ||
            (hint?.name.startsWith("Forest Temple") && barrens.some(x => x.name === "Forest Temple")) ||
            (hint?.name.startsWith("Fire Temple") && barrens.some(x => x.name === "Fire Temple")) ||
            (hint?.name.startsWith("Water Temple") && barrens.some(x => x.name === "Water Temple")) ||
            (hint?.name.startsWith("Shadow Temple") && barrens.some(x => x.name === "Shadow Temple")) ||
            (hint?.name.startsWith("Spirit Temple") && barrens.some(x => x.name === "Spirit Temple")) ||
            (hint?.name.startsWith("Hyrule Castle") && barrens.some(x => x.name === "Hyrule Castle")) ||
            (hint?.name.startsWith("OGC") && barrens.some(x => x.name === "Ganon Castle Ground")) ||
            (hint?.name.startsWith("Wasteland") && barrens.some(x => x.name === "Haunted Wasteland"))
            
}